export default "__VITE_ASSET__DAClCCYZ__"